import './campaign-line-summary.scss';

import { bool, func, string } from 'prop-types';
import React from 'react';
import { Badge, Label } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import DateRange from '../../generic/DateRange';
import { campaignLineShape } from '../../prop-types';

const CampaignLineSummary = ({ line, isSelected, onChange, nameKey }) => {
  const checkboxId = `${nameKey}.${line.id}`;
  return (
    <ul className="list-unstyled c-campaign-line-summary">
      <li>
        <Label for={checkboxId} hidden>
          Select campaign line
        </Label>
        <input
          type="checkbox"
          id={checkboxId}
          name={checkboxId}
          checked={isSelected}
          onChange={onChange}
        />
      </li>
      <li className="qa-country">{line.country && line.country.name}</li>
      <li>
        <Badge color="info">{line.gender}</Badge>
      </li>
      <li>
        <CurrencyFormat value={line.spendableBudget} text />
      </li>
      <li className="ml-auto">
        <DateRange
          startName={`${line.id}.startDate`}
          endName={`${line.id}.endDate`}
          startDate={line.startDate}
          endDate={line.endDate}
          small
          readOnly
        />
      </li>
    </ul>
  );
};

CampaignLineSummary.propTypes = {
  nameKey: string.isRequired,
  line: campaignLineShape.isRequired,
  isSelected: bool.isRequired,
  onChange: func.isRequired,
};

export default CampaignLineSummary;
